import { apiClient } from './client';

export type SearchType = 'name' | 'email' | 'phone' | 'student_id';

export interface SearchResult {
  id: number;
  name: string;
  email: string;
  phone: string;
  type: string;
  school_code: string;
  school_name: string;
}

export interface SearchFilters {
  type: SearchType;
  term: string;
  schoolCode?: string;
}

export interface SchoolOption {
  code: string;
  label: string;
}

export async function search(filters: SearchFilters): Promise<SearchResult[]> {
  const params = new URLSearchParams();

  params.append('type', filters.type);
  params.append('term', filters.term);
  if (filters.schoolCode) {
    params.append('schoolCode', filters.schoolCode);
  }

  const response = await apiClient.get<SearchResult[]>(`/api/v2/search?${params.toString()}`);
  return response.data;
}

export async function getSearchSchools(): Promise<SchoolOption[]> {
  const response = await apiClient.get<SchoolOption[]>('/api/v2/search/schools');
  return response.data;
}
